import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LazyLoadEvent } from 'primeng/api';
import { Cliente } from 'src/app/admihair/api/dto/cliente';
import { Paginador } from 'src/app/admihair/api/dto/paginacao/paginador';
import { ClienteService } from 'src/app/admihair/service/cliente.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { ContatoClienteService } from 'src/app/admihair/service/contato-cliente.service';
import { ContatoCliente } from 'src/app/admihair/api/dto/contato-cliente';

@Component({
  selector: 'app-select-cliente-dialog',
  templateUrl: './select-cliente-dialog.component.html',
  styleUrls: ['./select-cliente-dialog.component.scss']
})
export class SelectClienteDialogComponent extends AdmihairBaseComponent implements OnInit, OnChanges {

  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() selecionar = new EventEmitter<Cliente>();

  @ViewChild('filter') filter?: ElementRef<HTMLInputElement>;

  view: string = 'LISTAGEM';
  loadingCadastroCliente: boolean = false;

  clientes: Cliente[] = [];
  totalRegistros: number = 0;
  loading: boolean = false;

  private empresaId!: number;

  private lazyParams: LazyLoadEvent = {
    first: 0,
    rows: 5
  };

  private readonly ORDENACAO_PADRAO = 'nome,asc';
  private readonly STATUS_ATIVO = true;

  inputBusca?: string = '';

  constructor(private clienteService: ClienteService,
    private contatoClienteService: ContatoClienteService,
    private utilStorageService: UtilStorageService,
    erroService: ErroService,
        storageService: UtilStorageService
  ) {super(erroService, storageService)}
  
  ngOnInit(): void {
    this.empresaId = this.utilStorageService.getEmpresa().id!;
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible']?.currentValue === true) {
      this.resetarEstado();
      this.carregarClientes();
    }
  }

  onLazyLoad(event: LazyLoadEvent) {
    if (!this.visible) {
      return;
    }

    this.lazyParams = event;
    this.carregarClientes();
  }

  carregarClientes() {
    this.loading = true;
    const tamanho = this.obterTamanhoPagina();
    const pagina = this.obterPagina();
    const ordenacao = this.obterOrdenacao();
    
    this.clienteService.listarClientesPorEmpresaESituacaoETextoBuscaPaginado(
      this.empresaId, this.STATUS_ATIVO, pagina, tamanho, ordenacao, this.inputBusca
    ).subscribe({
      next: (data: Paginador<Cliente>) => {
        this.clientes = data.content;
        this.totalRegistros = data.totalElements;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
      }
    });
  }


  buscar(event: Event) {
    this.inputBusca = (event.target as HTMLInputElement).value;
    this.resetarPaginacao();
    this.carregarClientes();
  }

  limpar() {
    this.inputBusca = '';
    this.filter?.nativeElement && (this.filter.nativeElement.value = '');
    this.resetarPaginacao();
    this.carregarClientes();
  }
  
  selecionarCliente(cliente: Cliente) {
    this.selecionar.emit(cliente);
    this.fechar();
  }

  fechar() {
    this.visibleChange.emit(false);
  }


  abrirJanelaDetalhe(id?: number) {
    const url = `${window.location.origin}/#/janela-empresa/cliente-ficha-resumo/${id}`;
    const newWindow = window.open(url, '_blank', 'width=800,height=600,menubar=no,toolbar=no,location=no,status=no');
    if (newWindow) {
      newWindow.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
          newWindow.close();
        }
      });
    }
  }

  resetarEstado() {
    this.view = 'LISTAGEM';
    this.inputBusca = '';
    this.resetarPaginacao();
    this.clientes = [];
  }

  resetarPaginacao() {
    this.lazyParams = {
      ...this.lazyParams,
      first: 0
    };
  }

  obterTamanhoPagina(): number {
    return this.lazyParams.rows ?? 5;
  }
  obterPagina(): number {
    return (this.lazyParams.first ?? 0) / (this.lazyParams.rows ?? 5);
  }
  
  obterOrdenacao(): string {
    if (!this.lazyParams.sortField) {
      return this.ORDENACAO_PADRAO;
    }
    const direcao = this.lazyParams.sortOrder === 1 ? 'asc' : 'desc';
    return `${this.lazyParams.sortField},${direcao}`;
  }


  cadastroCliente() {
    this.view = 'CADASTRO';
  }


  cadastrarCliente(formUsuario: FormGroup) {
    this.loadingCadastroCliente = true;
    let novoCliente: Cliente = {
      nome: formUsuario.value.nome,
      apelido: formUsuario.value.apelido,
      cpf: formUsuario.value.cpf,
      //aniversario: this.fomatarAniversarioCliente(formUsuario.value.aniversario),
      email: formUsuario.value.email,
      empresa: this.getEmpresa()
    }

    this.clienteService.salvar(novoCliente).subscribe({
      next: (data: Cliente) => {
        this.salvarContatoCliente(data, formUsuario.value.telefone);
      },
      error: (err: any) => {
        this.exibirMensagemErroDialog(err);
        this.loadingCadastroCliente = false;
      }
    })
  }

  salvarContatoCliente(cliente: Cliente, telefone: string) {
    const contato: ContatoCliente = {
      cliente: cliente,
      numero: telefone,
      principal: true
    }
    this.contatoClienteService.salvar(contato).subscribe({
      next: () => {
        this.loadingCadastroCliente = false;
        this.selecionarCliente(cliente);
      },
      error: (err: any) => {
        this.loadingCadastroCliente = false;
        this.exibirMensagemErroDialog(err);
      }
    })
  }

}
